import { render, staticRenderFns } from "./sentenceM9.vue?vue&type=template&id=7d2e3aea&scoped=true&"
import script from "./sentenceM9.vue?vue&type=script&lang=js&"
export * from "./sentenceM9.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM9.vue?vue&type=style&index=0&id=7d2e3aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e3aea",
  null
  
)

export default component.exports